import { render, staticRenderFns } from "./email_list.vue?vue&type=template&id=27ac2259"
import script from "./email_list.vue?vue&type=script&lang=js"
export * from "./email_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports